import { render, staticRenderFns } from "./MewTooltip.vue?vue&type=template&id=87c4b75a"
import script from "./MewTooltip.vue?vue&type=script&lang=js"
export * from "./MewTooltip.vue?vue&type=script&lang=js"
import style0 from "./MewTooltip.vue?vue&type=style&index=0&id=87c4b75a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports